import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { TestimonialService } from '../../../_services/testimonial.service';
import { Testimonial } from '../../../_models/testimonial';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../../../environments/environment';

@Component({
    selector: 'app-testimonials-list',
    templateUrl: './testimonials-list.component.html',
    styleUrls: ['./testimonials-list.component.css'],
    standalone: false
})
export class TestimonialsListComponent implements OnInit {
    title = 'Testimonials';
    loading = true;
    testimonials: Testimonial[] = [];
    showDeleteModal = false;
    showDetailsModal = false;
    testimonialToDelete: Testimonial | null = null;
    selectedTestimonial: Testimonial | null = null;
    loadingDetails = false;

    constructor(
        private testimonialService: TestimonialService,
        private titleService: Title,
        private router: Router,
        private toastr: ToastrService
    ) {
        this.titleService.setTitle(this.title);
    }

    ngOnInit() {
        this.loadTestimonials();
    }

    loadTestimonials() {
        this.loading = true;
        this.testimonialService.loadAllAdmin().subscribe({
            next: (response: any) => {
                const items = response.data?.data || response.data || response || [];
                this.testimonials = items.map((item: any) => ({
                    ...item,
                    profilePhotoPath: this.getFullPhotoUrl(item.profilePhotoPath)
                }));
                this.loading = false;
            },
            error: () => {
                this.toastr.error('Failed to load testimonials');
                this.loading = false;
            }
        });
    }

    getFullPhotoUrl(path: string): string {
        if (!path) return '';
        if (path.startsWith('http')) return path;
        return `${environment.apiUrl}/${path}`;
    }

    addTestimonial() {
        this.router.navigateByUrl('/admin/testimonial/add');
    }

    viewDetails(testimonial: Testimonial) {
        this.selectedTestimonial = testimonial;
        this.showDetailsModal = true;
        this.loadingDetails = true;

        this.testimonialService.loadOne(testimonial.id).subscribe({
            next: (response: any) => {
                const data = response.data || response;
                this.selectedTestimonial = {
                    ...data,
                    profilePhotoPath: this.getFullPhotoUrl(data.profilePhotoPath)
                };
                this.loadingDetails = false;
            },
            error: () => {
                this.loadingDetails = false;
                this.toastr.error('Failed to load testimonial details');
            }
        });
    }

    closeDetails() {
        this.showDetailsModal = false;
        this.selectedTestimonial = null;
    }

    editFromModal() {
        if (this.selectedTestimonial) {
            this.router.navigate(['/admin', 'testimonial', this.selectedTestimonial.id, 'edit']);
            this.closeDetails();
        }
    }

    confirmDelete(testimonial: Testimonial) {
        this.testimonialToDelete = testimonial;
        this.showDeleteModal = true;
    }

    cancelDelete() {
        this.showDeleteModal = false;
        this.testimonialToDelete = null;
    }

    deleteTestimonial() {
        if (!this.testimonialToDelete) return;

        this.testimonialService.delete(this.testimonialToDelete.id).subscribe({
            next: () => {
                this.toastr.success('Testimonial deleted successfully');
                this.showDeleteModal = false;
                this.testimonialToDelete = null;
                this.loadTestimonials();
            },
            error: () => {
                this.toastr.error('Failed to delete testimonial');
                this.showDeleteModal = false;
                this.testimonialToDelete = null;
            }
        });
    }
}
